export default "__VITE_ASSET__IXZf0zXe__"